import React from 'react';
import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8">
        <div className="mb-8">
          <Link to="/" className="text-[#0EA5E9] hover:text-[#0284c7] text-sm font-medium">
            ← Back to PassportTalk
          </Link>
        </div>
        
        <h1 className="text-4xl font-bold text-travel-navy font-outfit mb-4">Refund Policy</h1>
        <p className="text-sm text-slate-600 mb-8">
          <strong>Effective Date:</strong> January 1, 2025<br />
          <strong>Last Updated:</strong> January 5, 2025
        </p>

        <div className="prose prose-slate max-w-none">
          <h2>Overview</h2>
          <p>
            This Refund Policy outlines the conditions under which PassportTalk will consider refunds for our services. Please read this policy carefully before using our paid services.
          </p>

          <div className="bg-[#0EA5E9]/10 border-2 border-[#0EA5E9]/20 rounded-xl p-6 my-6">
            <p className="font-semibold text-travel-navy mb-3">Beta Program Note</p>
            <p className="text-sm">
              PassportTalk is currently in beta. During this period, refund requests are handled on a case-by-case basis with additional flexibility for beta users experiencing service issues.
            </p>
          </div>

          <h2>1. AI Translation Service</h2>
          <p>
            <strong>Current Status:</strong> Free during beta<br />
            <strong>Refund Eligibility:</strong> Not applicable (no charge)
          </p>

          <h2>2. Live Agent Calls</h2>
          <h3>2.1 Refund Eligibility</h3>
          <p>Refunds may be considered for:</p>
          <ul>
            <li><strong>Technical Issues:</strong> Call disconnected due to our system failure</li>
            <li><strong>Agent Unavailability:</strong> Agent disconnected without completing service</li>
            <li><strong>Quality Issues:</strong> Agent unable to provide translation assistance</li>
            <li><strong>Billing Errors:</strong> Incorrect charges or duplicate billing</li>
          </ul>

          <h3>2.2 Non-Refundable Situations</h3>
          <p>Refunds are NOT provided for:</p>
          <ul>
            <li>Completed calls where service was provided</li>
            <li>User-initiated disconnection</li>
            <li>Poor network connection on user&apos;s end</li>
            <li>Dissatisfaction with translation accuracy (translations are best-effort)</li>
            <li>User error in selecting wrong agent or scenario</li>
          </ul>

          <h2>3. How to Request a Refund</h2>
          <h3>3.1 Contact Us</h3>
          <p>Email: <strong>support@passtalkapp.com</strong></p>
          <p>Subject line: &ldquo;Refund Request - [Your Email]&rdquo;</p>

          <h3>3.2 Required Information</h3>
          <ul>
            <li>Your account email</li>
            <li>Date and time of the call</li>
            <li>Agent name (if known)</li>
            <li>Description of the issue</li>
            <li>Any relevant screenshots or evidence</li>
          </ul>

          <h3>3.3 Timeframe</h3>
          <ul>
            <li><strong>Request Window:</strong> Within 7 days of the charge</li>
            <li><strong>Processing Time:</strong> 5-10 business days</li>
            <li><strong>Refund Method:</strong> Original payment method</li>
          </ul>

          <h2>4. Refund Amounts</h2>
          <ul>
            <li><strong>Full Refund:</strong> Technical issues on our end, billing errors</li>
            <li><strong>Partial Refund:</strong> Service partially delivered before issue</li>
            <li><strong>No Refund:</strong> Non-refundable situations listed above</li>
          </ul>

          <h2>5. Disputes</h2>
          <p>
            If you disagree with a refund decision, you may:
          </p>
          <ul>
            <li>Request a review by emailing support@passtalkapp.com</li>
            <li>Provide additional documentation</li>
            <li>Escalate to a supervisor if needed</li>
          </ul>

          <h2>6. Contact Information</h2>
          <p><strong>For refund requests and questions:</strong></p>
          <ul className="list-none">
            <li><strong>Email:</strong> support@passtalkapp.com</li>
            <li><strong>Response Time:</strong> Within 48 hours</li>
          </ul>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <p className="text-sm text-slate-600 text-center">
            <strong>Last Updated:</strong> January 5, 2025 | <strong>Version:</strong> 1.0 (Beta)
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
